exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.routes .vis-item-content {\n  height: 20px;\n\n  overflow: hidden;\n  font-size: 11px;\n}\n.routes .vis-item .vis-item-content {\n  padding: 0px;\n}\n.routes .vis-item-content .material-icons {\n  font-size: 12px;\n}\n.payments-done {\n  padding-right: 3px;\n\n  background-color: rgba(170, 255, 0, 0.49);\n}\n.payments-none {\n  padding-right: 3px;\n  background-color: rgba(255, 0, 0, 0.49);\n  //border: 1px dashed red;\n}\n.payments-some {\n  padding-right: 3px;\n  background-color: rgba(245, 197, 77, 0.53);\n}\n.payments-un {\n  padding-right: 3px;\n  border: 2px solid red;\n}\n", ""]);

// exports
